import { input, output } from '@b2b/types/core';
import angular, { IOnChangesObject } from 'angular';
import { REDEMPTION_LIMIT_HINT, RedemptionLimitField } from './coupon-redemption-limits';


export class CouponRedemptionLimitFieldController {
  name = input.required('');
  label = input.required('');
  helpText = input('');
  field = input<RedemptionLimitField>({ enabled: false, value: '' });
  error = input<string | undefined>(undefined);
  onChange = output<RedemptionLimitField>();

  readonly hint = REDEMPTION_LIMIT_HINT;
  enabled = false;
  value = '';

  $onChanges(changes: IOnChangesObject) {
    if (changes.field && this.field) {
      this.enabled = !!this.field.enabled;
      this.value = this.field.value ?? '';
    }
  }

  toggle() {
    if (!this.enabled) {
      this.value = '';
    }
    this.emit();
  }

  emit() {
    this.onChange({ $event: { enabled: this.enabled, value: this.value } });
  }
}

export const CouponRedemptionLimitFieldComponentModule = angular
  .module('acme.view.application.coupons.component.redemptionLimitField', [])
  .component('acmeCouponRedemptionLimitField', {
    templateUrl: 'views/application/views/coupons/redemption-limits/redemption-limit-field.component.tpl.html',
    controller: CouponRedemptionLimitFieldController,
    controllerAs: '$ctrl',
    bindings: {
      name: '@',
      label: '<',
      helpText: '<',
      field: '<',
      error: '<',
      onChange: '&',
    },
  }).name;
